export default {
  WORDS: "WORDS",
  NEXT_WORD: "NEXT_WORD",
  PREV_WORD: "PREV_WORD",
  TOGGLE_LOADER: "TOGGLE_LOADER",
  SHOW_TOAST_NOTIFY: "SHOW_TOAST_NOTIFY",
  TOOGLE_ALLOW_SWITCHING: "TOOGLE_ALLOW_SWITCHING",
  SET_CURRENT_INDEX: "SET_CURRENT_INDEX",
};
